
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dkxqfiilbcuwlnxgtwkq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRreHFmaWlsYmN1d2xueGd0d2txIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDM0NzA3NDksImV4cCI6MjAxOTA0Njc0OX0.cCmBaB_MjXjERmqMBK9uSy6cWE0-8956uUejD6jWtvw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
